import * as React from "react"

const Input = React.forwardRef(({ className = "", type = "text", ...props }, ref) => {
    const baseClasses =
        "flex h-10 rounded-md border  bg-background px-3 py-2 text-sm  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"

    return (
        <input
            ref={ref}
            type={type}
            className={`${baseClasses} ${className}`}
            {...props}
        />
    )
})

Input.displayName = "Input"

export { Input }
